import { request } from '@/utils/request'

//审批加工送货单
export function approvalApi(data, that) {
    return request({
        url: '/srm/procSentForm/auditSentForm',
        data: data,
        params: {},
        that,
        method: 'post',
    })
}
//多人审批加工送货单
export function auditApi(data, that) {
    return request({
        url: '/srm/procSentForm/submitAudit',
        data: data,
        params: {},
        that,
        method: 'post',
    })
}
//多人审批进度、审批结果、不通过原因
export function auditProgressApi(params, that) {
    return request({
        url: '/srm/procSentForm/auditProgress',
        data: {},
        params: params,
        that,
        method: 'get',
        showSuccessNotification: false
    })
}
//钉钉通知审批加工送货单
export function urgeApi(data, that) {
    return request({
        url: '/srm/procSentForm/urge',
        data: {},
        params: data,
        that,
        method: 'get',
    })
}

//查加工单表头
export function getOutSourceHeadApi(data, that) {
    return request({
        url: '/srm/procForm/queryHead',
        data: data,
        params: {},
        that,
        method: 'post',
    })
}
//查加工单子项
export function getOutSourceItemApi(data, that) {
    return request({
        url: '/srm/procForm/query',
        data: data,
        params: {},
        that,
        method: 'post',
    })
}

//生成加工送货单
export function genProcSendApi(data, that) {
    return request({
        url: '/srm/procSentForm/addSentForm',
        data: data,
        params: {},
        that,
        method: 'post',
    })
}


//送货单表头
export function getOutSourceSendApi(data, that) {
    return request({
        url: '/srm/procSentForm/queryHead',
        data: data,
        params: {},
        that,
        method: 'post',
        load: true,
    })
}

//送货单子项
export function getOutSourceSendItemApi(data, that) {
    return request({
        url: '/srm/procSentForm/query',
        data: data,
        params: {},
        that,
        method: 'post',
    })
}

//删除送货单
export function delProcSendApi(delData, that) {
    return request({
        url: '/srm/procSentForm/removeForm',
        data: {},
        params: { formCode: delData },
        that,
        method: 'post',
    })
}
//删除送货单子项
export function delProcSendItemApi(delData, that) {
    return request({
        url: '/srm/procSentForm/removeItem',
        data: delData,
        params: {},
        that,
        method: 'post',
    })
}

//查加工商
export function getProcSupplierApi(search_obj, that) {
    return request({
        url: '/srm/procSupplier/query',
        data: search_obj,
        params: {},
        that,
        method: 'post',
    })
}